import * as _ from 'underscore';
import { Telemetry, ValidTelemetryEvent } from '../../../commonInfra/services/Telemetry';
import { SpaceType, SpaceInfo } from '../../state/SpaceInfo';

// List of events. The event name will be what appears in the database.
export enum CollectionTelemetryEvents {
  CreateCollectionClicked = 'CreateCollectionClicked',
  CollectionsAddItemsDialogResult = 'CollectionsAddItemsDialogResult'
}

export enum CreateCollectionClickedSourceOptions {
  NewCollectionButton = 'New Collection Button',
  NewMenu = 'New Menu',
  DialogCreateButton = 'Dialog Create Button',
}

export interface CreateCollectionClickedEvent extends ValidTelemetryEvent<CreateCollectionClickedEvent> {
  type: CollectionTelemetryEvents.CreateCollectionClicked;
  location: SpaceType;
  source: CreateCollectionClickedSourceOptions;
}

export function sendCreateCollectionClickedTelemetry(location: SpaceType, source: CreateCollectionClickedSourceOptions) {
    Telemetry.sendEvent<CreateCollectionClickedEvent>({
      type: CollectionTelemetryEvents.CreateCollectionClicked,
      location: location,
      source: source,
    });
}

export type ManageItemsResult = 'ok' | 'cancel' | 'cancel-from-create';

export interface ManageItemsTelemetry {
  result: ManageItemsResult;
  creatingCollection: boolean;
  firstCollectionFlow: boolean;
  numCollectionsShown: number;
  numItemsToBeAdded: number;
  numCollectionsAddedTo: number;
  itemsAddedToNewCollections: boolean;
  numCollectionsCreatedAttempts: number;
  numCollectionsCreated: number;
}

export interface CollectionsAddItemsDialogResultEvent extends Omit<ManageItemsTelemetry, 'creatingCollection'>, ValidTelemetryEvent<CollectionsAddItemsDialogResultEvent> {
  type: CollectionTelemetryEvents.CollectionsAddItemsDialogResult;
  location: SpaceType;
}

export const initialManageItemsTelemetry = (): ManageItemsTelemetry => {
  return {
    result: 'cancel',
    creatingCollection: false,
    firstCollectionFlow: false,
    numCollectionsShown: 0,
    numItemsToBeAdded: 0,
    numCollectionsAddedTo: 0,
    itemsAddedToNewCollections: false,
    numCollectionsCreatedAttempts: 0,
    numCollectionsCreated: 0,
  };
};

export function sendManageItemsEvent(data: ManageItemsTelemetry, spaceInfo: SpaceInfo) {
  if (_.isUndefined(spaceInfo)) {
    return;
  }

  Telemetry.sendEvent<CollectionsAddItemsDialogResultEvent>({
    type: CollectionTelemetryEvents.CollectionsAddItemsDialogResult,
    location: spaceInfo.spaceType,
    result: data.result,
    firstCollectionFlow: data.firstCollectionFlow,
    numCollectionsCreatedAttempts: data.numCollectionsCreatedAttempts,
    numCollectionsCreated: data.numCollectionsCreated,
    itemsAddedToNewCollections: data.itemsAddedToNewCollections,
    numCollectionsShown: data.numCollectionsShown,
    numItemsToBeAdded: data.numItemsToBeAdded,
    numCollectionsAddedTo: data.numCollectionsAddedTo,
  });
}